<template>
  <div class="component" :style="{ '--depth': depth }">
    <div>
      <button
        @click="toggleExpand"
        class="tw-text-left tw-w-full tw-flex tw-items-center tw-gap-2 tw-py-2 tw-overflow-hidden"
      >
        <Icon
          :icon="icon"
        />

        <Title
          size="5"
          class="tw-flex-1 tw-truncate"
        >
          <span class="name">
            {{ node.name }}
          </span>
        </Title>
        <Title
          size="5"
          class="tw-text-right tw-w-auto tw-overflow-visible tw-text-nowrap"
        >
          <span class="total">
            {{ formatTotal(node.total) }}
          </span>
        </Title>
      </button>
    </div>

    <div
      v-if="node && node.expanded && node.children"
      class="tw-pl-4 tw-max-w-full"
    >
      <PortfolioSummaryTree
        v-for="(child, index) in node.children"
        :key="index"
        :node="child"
        :depth="depth + 1"
      />
    </div>
  </div>
</template>

<script>
import { Icon, Title } from '@stakeui';

export default {
  name: "PortfolioSummaryTree",
  props: {
    node: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    depth: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  components: {
    Icon,
    Title,
  },
  computed: {
    icon() {
      if (!this.node.children || this.node.children.length === 0) {
        return 'fas fa-circle';
      }

      if (this.node.expanded) {
        return 'fas fa-chevron-down';
      }

      return 'fas fa-chevron-right'
    }
  },
  methods: {
    toggleExpand() {
      this.node.expanded = !this.node.expanded;
    },
    formatTotal(total) {
      if (typeof total !== "number" || isNaN(total)) {
        return "0.00";
      }
      return total.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style scoped>
button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  max-width: 100%;
}

button:focus {
  outline: none;
}

.name,
.total {
  font-size: calc(1em - calc(0.125em * var(--depth)));
}
</style>
